import { useTLang } from 'intl/intl';

export function useTurnOffProductLang() {
  return {
    title: useTLang({ id: 'menuPage.turnOff.item.title.product' }),
    action: {
      primaryBtn: useTLang({ id: 'menuPage.turnOff.item.action.primaryBtn' }),
    },
  };
}
